import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ApplicationUtilsService } from '../../../services/application-utils.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input() buildVersion: string;
  @Output() releaseNotes = new EventEmitter<void>();

  email: string = 'LTLITArtemisSupport@xpo.com';
  subject: string = 'Feedback - Edge Artemis';

  constructor(public applicationUtilsService: ApplicationUtilsService) {}

  openHelpLink(): void {
    window.open(this.getHelpLink());
  }

  getHelpLink(): string {
    return this.applicationUtilsService.helpLink;
  }

  getMailLink(): string {
    return `mailto:${this.email}?subject=${this.subject}`;
  }
}
